"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationViewState_1 = require("../store/schema/NotificationViewState");
var removeNotification_1 = require("../actions/removeNotification");
var notificationHandlers = {};
function ensureNotificationHandlerRegistered(actionType, handler) {
    var actionTypeString = NotificationViewState_1.NotificationActionType[actionType];
    if (!notificationHandlers[actionTypeString]) {
        notificationHandlers[actionTypeString] = handler;
    }
}
exports.ensureNotificationHandlerRegistered = ensureNotificationHandlerRegistered;
function handleNotification(notification) {
    var handler = notificationHandlers[NotificationViewState_1.NotificationActionType[notification.actionType]];
    if (handler) {
        handler(notification);
    }
    removeNotification_1.default(notification);
}
exports.handleNotification = handleNotification;
//# sourceMappingURL=notificationHandler.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-header-toast-notification/lib/utils/notificationHandler.js
// module id = 368
// module chunks = 3 14 105 106 107